import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { ReportPage } from '@/features/reports'

const reportSearchSchema = z.object({
  page: z.number().optional(),
  pageSize: z.number().optional(),
  filter: z.string().optional(),
  params: z.record(z.string(), z.string()).optional(),
})

export const Route = createFileRoute('/_authenticated/reports/$slug/')({
  validateSearch: reportSearchSchema,
  component: ReportPage,
})
